import { render, staticRenderFns } from "./non_gfm_markdown.vue?vue&type=template&id=6133c046"
import script from "./non_gfm_markdown.vue?vue&type=script&lang=js"
export * from "./non_gfm_markdown.vue?vue&type=script&lang=js"
import style0 from "./non_gfm_markdown.vue?vue&type=style&index=0&id=6133c046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports